import React, { useState , useContext } from "react";
import Blame from "../../audio/Blame.mp3";
import Alone from "../../audio/Alone I break.mp3";
import Around from "../../audio/Around The World.mp3";
import Corre from "../../audio/Corre.mp3";
import Dont from "../../audio/Dont Speak.mp3";
import Farplane from "../../audio/Farplane.mp3";
import Lisa from "../../audio/Gustavo Cerati.mp3";
import Mayday from "../../audio/Mayday.mp3";
import Ramones from "../../audio/She belongs to me.mp3";
import Wait from "../../audio/Wait for It.mp3";
import Twelve from "../../audio/Twelve Years.mp3";
import Conversation from "../../audio/Conversation.mp3";
import theDepression from "../../audio/The Depression.mp3";
import myDecember from "../../audio/My December.mp3";
import Stuck from '../../audio/Stuck.mp3'
import Cryboy from '../../audio/Cry boy.mp3'
import { VideoContext } from '../../context/VideoContext'

import "./audio.css";
export function Audio(){
  const { changeData  } = useContext( VideoContext )
  const ifContidion = { display: "none" };
  const elseCondition = { display: "block" };
  const type = "mp3";
  const [ youHere, setyouHere ] = useState("More play List");
  const [ condition, setCondition ] = useState(ifContidion);
  function chek(){
    if ( youHere === "More play List" ) {
      setyouHere("Less play List");
      setCondition(elseCondition);
    } else {
      setyouHere("More play List");
      setCondition(ifContidion);
    }
  }
  function handlerEvent () {  changeData()  } 

  const tracks = [
    { url: Blame,band: "Korn",title: "Blame",tags: ["Nú Metal"],distributed: "condition", },
    { url: Alone,band: "Korn",title: "Alone",tags: ["Nú Metal"],distributed: "condition", },
    { url: Around,band: "Red hot chili pepper",title: "Around the world",tags: ["Hard rock"],distributed: "condition", },
    { url: Corre,band: "Lupus",title: "Corre",tags: ["Nú Metal"], },
    { url: Dont,band: "No doubt",title: "Dont speak",tags: ["Pop"], },
    { url: Farplane,band: "Zero mindset",title: "Farplane",tags: ["Nú Metal"], },
    { url: Lisa,band: "Soda estereo",title: "Lisa",tags: ["Pop rock"], },
    { url: Mayday,band: "Islander",title: "Mayday",tags: ["Rock Metal"], },
    { url: Conversation,band: "Zero mindset",title: "Conversation",tags: ["Nü Metal"], },
    { url: Ramones,band: "The ramones",title: "She belongs to me",tags: ["Punk Rock"], },
  ];
  const tracks2 = [
    { url: Wait,band: "Islander",title: "Wait for It",tags: ["Punk Rock"], },
    { url: Twelve,band: "Roving",title: "Twelve Years",tags: ["Grunge"], },
    { url: theDepression,band: "...",title: "The Depression",tags: ["Nü Metal"], },
    { url: myDecember,band: "Zero mindset",title: "My December",tags: ["Linkin Park cover"], },
    { url: Stuck,band: "Roving",title: "Stuck",tags: ["Grunge"], },
    { url: Cryboy,band: "AA=",title: "Cry boy",tags: ["Grunge"], },
  ];
  return (
    <>
      <p id="kiss" onClick={() => { chek(); }}>{ youHere }</p>
      <div className="container-div-audio" style={{ userSelect: 'none', WebkitUserSelect: 'none' }} >
        {tracks.map( (e,index) =>(
          <div className="div-audio" key={index} onPlay={ handlerEvent } style={condition}>
            <hgroup><h1 className="tittle__audio">{e.title}</h1></hgroup>
            <p id="kiss2"><span className="band__audio">{e.band}<br/><code className="code__audio">[ {e.tags} ]</code></span></p>
            <audio className="div__audio" controls={true} preload="none" type={type}  src={e.url}/>
            <hr />
          </div>
        ) )}
        {tracks2.map( (e,index) =>(
          <div className="div-audio" key={index} onPlay={ handlerEvent }  >
            <hgroup><h1 className="tittle__audio">{e.title}</h1></hgroup>
            <p id="kiss2"><span className="band__audio">{e.band}<br/><code className="code__audio">[ {e.tags} ]</code></span></p>
            <audio className="div__audio" controls={true} preload="auto" type={type}src={e.url}/>
            <hr />
          </div>
        ))}
      </div>
    </>
  );
}
